import { initContract } from '@ts-rest/core';
import { z } from 'zod';

import { TSDStatus } from '@e-origin/shared';

import { TSDListItemSchema, TSDRetrieveCriteriaSchema } from './schemas';

const c = initContract();

export const adminTsdContract = c.router({
  retrieveTsds: {
    method: 'POST',
    path: '/admin/tsds',
    body: z.object({
      criteria: TSDRetrieveCriteriaSchema.optional(),
    }),
    responses: {
      200: z.object({
        data: z.object({
          list: z.array(TSDListItemSchema),
          totalItems: z.number(),
        }),
      }),
      500: z.object({
        message: z.string(),
      }),
    },
  },

  updateTsdStatus: {
    method: 'PATCH',
    path: '/admin/tsd-status/:tsdId',
    pathParams: z.object({
      tsdId: z.string(),
    }),
    body: z.object({
      status: z.nativeEnum(TSDStatus),
    }),
    responses: {
      200: z.object({
        message: z.string(),
      }),
      500: z.object({
        message: z.string(),
      }),
    },
  },

  deleteTsd: {
    method: 'DELETE',
    path: '/admin/tsds/:tsdId',
    pathParams: z.object({
      tsdId: z.string(),
    }),
    body: c.noBody(),
    responses: {
      200: z.object({}),
      500: z.object({
        message: z.string(),
      }),
    },
  },

  importTsd: {
    method: 'POST',
    path: '/admin/import-tsd',
    body: z.object({
      customerId: z.string(),
      templateId: z.string(),
      declarantId: z.string(),
      userId: z.string(),
      resetCustomsData: z.string(),
    }),
    contentType: 'multipart/form-data',
    responses: {
      201: z.object({
        message: z.string(),
      }),
      400: z.object({
        message: z.string(),
      }),
    },
  },

  exportTsd: {
    method: 'GET',
    path: '/admin/export-tsd/:tsdId',
    pathParams: z.object({
      tsdId: z.string(),
    }),
    responses: {
      200: c.otherResponse({
        contentType: 'application/zip',
        body: z.any(),
      }),
      404: z.object({
        message: z.string(),
      }),
      500: z.object({
        message: z.string(),
      }),
    },
  },
});
